import React from "react";
import { Button, ButtonAsLinkProps } from "../Button/Button";
import clsx from "clsx";
import styles from "./PaginationButton.module.scss";

export interface PaginationButtonProps extends ButtonAsLinkProps {
  arrow: "left" | "right";
}

export const PaginationButton: React.FC<
  React.PropsWithChildren<PaginationButtonProps>
> = ({ arrow, className = "", ...buttonProps }) => {
  const icon = arrow == "left" ? "chevron-left" : "chevron-right";

  return (
    <Button
      className={clsx(className, styles.button)}
      variant="elevated"
      iconName={icon}
      {...buttonProps}
    ></Button>
  );
};
